import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'screens/components/basic/Button';
import DialogInput from 'screens/components/advanced/DialogInput';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

class PastDueDialog extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showDialog: false,
            branchChange: true
        };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.applicationSetting.paymentPastDue != null && newProps.applicationSetting.paymentPastDue && localStorage.getItem("TECHPOS_PastDueDialog") == "") {
            this.setState({ showDialog: true });
            localStorage.setItem("TECHPOS_PastDueDialog", "Showed");
        }
    }

    close = () => {
        this.setState({ showDialog: false });
    }

    render() {
        return (
            <DialogInput
                // modal={true}
                open={this.state.showDialog}
                autoScrollBodyContent={false}
                title={<DialogHeaderWithClose noBackground handleClose={() => this.close()}/>}
                className={'PastDueDialog'}>
                    SUSPENSION NOTICE  - Your account payment is past due, and it will be suspended shortly
            </DialogInput >
        );
    }
}

function mapStateToProps(state) {
    return {
        applicationSetting: state.common.applicationSettings,
        branchId: state.common.branchId
    };
}

export default connect(mapStateToProps)(PastDueDialog);